import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { TylerMatTableDataSource } from '../../../shared-components/angular-material/extended.class';
import { MealService, LunchMealChoice } from '../meal-service.model';
import { StudentService } from '../../../shared-components/student/student.service';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { LoginSettings } from '../../../shared-modules/login/LoginSetting.model';
import { DatePipe } from '@angular/common';
import { AriaDirective } from '../../../shared-components/directives/aria.directive';
import { LoginService } from '../../../shared-modules/login/login.service';
import { detailExpand } from '../../../shared-components/angular-material/mat-animations';
import { LunchMenuChoicesComponent } from '../lunch-menu-choices/lunch-menu-choices.component';
import * as moment from 'moment';

@Component({
  selector: 'charges-and-deposits',
  templateUrl: './charges-and-deposits.component.html',
  animations: [detailExpand],
  providers: [DatePipe]
})
export class ChargesAndDepositsComponent implements OnInit {

  @Input() mealService: MealService[];
  @Input() lunchMealChoice: LunchMealChoice[];
  angularMatData = new TylerMatTableDataSource();
  columnsToDisplay: string[] = [];
  columnSpanToDisplay: string[] = [];
  @ViewChild(MatSort) sort: MatSort;
  LoginSettings: LoginSettings;
  V10: boolean;
  lunchMealChoicesDialogRef: MatDialogRef<LunchMenuChoicesComponent>;
  columnsToDisplayDetailRow: string[] = ['MealGroup', 'ItemType', 'Item', 'TransactionType', 'Charge', 'Deposit', 'Processed'];

  constructor(
    private loginService: LoginService,
    private studentService: StudentService,
    private datePipe: DatePipe,
    private dialog: MatDialog,
  ) {
    this.LoginSettings = this.loginService.LoginSettings;
    this.V10 = this.LoginSettings.V10;
    this.angularMatData = new TylerMatTableDataSource(this.mealService);
    if (this.V10 == false) {
      this.columnsToDisplay = ['More', 'Date', 'BreakFastMeal', 'BreakFastALaCarte', 'LunchMeal', 'LunchALaCarte', 'SnackMeal', 'SnackALaCarte', 'TotalPurchases', 'Deposits', 'Net', 'NetCharge', 'Balance', 'Overdrawn'];
      this.columnSpanToDisplay = ['More1', 'Date1', 'header-row-breakfast', 'header-row-lunch', 'header-row-snack'];
    } else {
      this.columnsToDisplay = ['More', 'Date', 'BreakFastMeal', 'BreakFastALaCarte', 'LunchMeal', 'LunchALaCarte', 'SnackMeal', 'SnackALaCarte', 'OtherMeal', 'OtherALaCarte', 'TotalPurchases', 'Deposits', 'Net', 'NetCharge', 'Balance'];
      this.columnSpanToDisplay = ['More1', 'Date1', 'header-row-breakfast', 'header-row-lunch', 'header-row-snack', 'header-row-other']
    }
  }

  ngOnInit() {
    this.angularMatData.data = this.mealService;
    setTimeout(() => {
      this.angularMatData.sort = this.sort;
    }, 0);

    this.angularMatData.sortingDataAccessor = (item: MealService, property: string) => {
      if (property == 'Date1') {
        return moment(item.Date).unix();
      }
      else if (item[property]) {
        return this.angularMatData.defaultSortingAccessor(item, property);
      }
    }
  }

  refreshGrid(mealService: MealService[], lunchMealChoice: LunchMealChoice[]) {
    this.angularMatData.data = mealService;
    this.lunchMealChoice = lunchMealChoice;
    setTimeout(() => {
      this.angularMatData.sort = this.sort;
    }, 0);
  }

  checkExpanded(row: any): boolean {
    return this.angularMatData.checkExpanded(row);
  }

  toggleExpanded(row: any) {
    this.angularMatData.toggleExpanded(row);
  }

  expandAll(expand: boolean) {
    this.angularMatData.expandAll(expand);
  }

  rowKeyPress(event: KeyboardEvent, row: any) {
    this.angularMatData.rowKeyPress(event, row);
  }

  getMealServiceAriaRow(row: MealService): string {
    let colList: string[] = [];
    let dataList: string[] = [];

    if (this.LoginSettings.V10 == true) {
      colList = ['Date', 'BreakFastMeal', 'BreakFastALaCarte', 'LunchMeal', 'LunchALaCarte',
        'SnackMeal', 'SnackALaCarte', 'OtherMeal', 'OtherALaCarte', 'TotalPurchases', 'Deposits',
        'Net', 'Balance'];

      dataList = [this.datePipe.transform(row.Date, 'MM/dd/yy'), row.BreakFastMeal, row.BreakFastALaCarte, row.LunchMeal, row.LunchALaCarte,
      row.SnackMeal, row.SnackALaCarte, row.OtherMeal, row.OtherALaCarte, row.TotalPurchases, row.Deposits, row.Net, row.Balance];
    }
    else {
      colList = ['Date', 'BreakFastMeal', 'BreakFastALaCarte', 'LunchMeal', 'LunchALaCarte',
        'SnackMeal', 'SnackALaCarte', 'TotalPurchases', 'Deposits', 'Net', 'Balance'];

      dataList = [this.datePipe.transform(row.Date, 'MM/dd/yy'), row.BreakFastMeal, row.BreakFastALaCarte, row.LunchMeal, row.LunchALaCarte,
      row.SnackMeal, row.SnackALaCarte, row.TotalPurchases, row.Deposits, row.Net, row.Balance];
    }
    return AriaDirective.concatAriaStrings(colList, dataList);
  }

  getLunchMealChoices(dateChoice: Date) {
    const selectedLunchMealChoice: LunchMealChoice = this.lunchMealChoice.filter(function (el) { return el.Date == dateChoice; })[0];
    this.lunchMealChoicesDialogRef = this.dialog.open(LunchMenuChoicesComponent, {
      disableClose: true,
      panelClass: 'tyl-mat-dialog',
      height: '300px',
      width: '400px',
      data: selectedLunchMealChoice
    });
  }

}
